<template>
  <v-app>

    <v-main id="main">
      <AppBar v-if="printValidate" ref="appBar"/>

      <div :style="`display:${printValidate ? 'flex' : 'block'};`">
        <ListPoints
          v-if="printValidate"
          ref="listPoints"
          class="cont-dir" 
          id="cont-dir"
          @onGeolocation="geolocation"
          @onSelectMode="selectMode"
          v-on:onPrint="print"/>

        <v-btn class="arrow-responsive" id="arrow-responsive" @click="toggleMenu()"><div>►</div></v-btn>

        <GoogleMap :id=" printValidate ? 'container' : 'container-print'" ref="googleMap" />
        <Indications v-if="!printValidate" id="indications-print"/>
      </div>

      <!-- <div v-if="!printValidate">

        <GoogleMap id="container-print" ref="googleMap" />
        
      </div> -->

      <v-bottom-sheet
        v-model="getDialog.activate"
        hide-overlay
        inset
      >
        <v-sheet
          class="text-center"
          height="70px"
        >
          <div class="pt-5 justify-center">
            <div>
              <v-icon large color="orange" class="mr-2">mdi-alert</v-icon>
              {{getDialog.message}}
            </div>
          </div>
        </v-sheet>
      </v-bottom-sheet>
    </v-main>
  </v-app>
</template>

<script>
import AppBar from './components/AppBar';
import GoogleMap from './components/GoogleMap';
import ListPoints from './components/ListPoints';
import Indications from './components/Indications';

import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'App',
  /* Componente principal de la apliación */
  components: {
    AppBar,
    GoogleMap,
    ListPoints,
    Indications
  },
  data: () => ({
    group: null,
    printValidate: true,
    validate: true
  }),
  computed: {
    ...mapGetters(['getDialog']),
  },
  methods: {
    ...mapActions(['addCenter', 'addRadius']),
    print() {
      this.printValidate = false;

      let self = this;
      setTimeout(function(){

        window.onbeforeprint = function () {
          self.printValidate = false;
        };

        window.onafterprint = function(){
          self.printValidate = true;
        };

        window.print(); 
        this.printValidate = true;
          
      }, 1000);

    },
    selectMode(mode){
      this.$refs.googleMap.generateRoute(mode);
    },
    geolocation(){
      this.$refs.appBar.geolocation();
    },
    toggleMenu(){
      document.getElementById("cont-dir").classList.toggle('width0');
      document.getElementById("arrow-responsive").classList.toggle('left0');
    }
  }
};
</script>

<style scoped>

@import url('https://fonts.googleapis.com/css?family=Montserrat:wght@500');

html, body {
  font-family: 'Montserrat';
}

#app {
  font-family: 'Montserrat';
}

.arrow-responsive{
  position: absolute;
  z-index: 3;
  top: 50%;
  margin: 0 auto;
  left: 0;
  border: 0;
  height: 60px;
  background: #c5c5c5;
  border-radius: 0 4px 4px 0;
  color: #767676;
  display: none;
  cursor: pointer;
  outline: none;
  transition: all .7s;
}
.arrow-responsive div{
  transition: all .7s;
}
.cont-dir {
  width: 28%;
  border-radius: 0;
  float: left;
  position: absolute;
  overflow-x: hidden;
  overflow-x: hidden;
  transition: all .7s;
  z-index: 3;
}
#container {
  max-width: 71%;
  height: calc(100% - 60px);
  right: 0;
  position: absolute !important;
}

#container-print {
  max-width: 100%;
  min-height: 70vh;
}

#indications-print {
  padding-left: 15%;
  padding-right: 15%;
  padding-top: 2rem;
}

#content-print {
  align-items: center !important;
  justify-content: center !important;

}

@media only screen and (max-width: 768px) {
  .arrow-responsive{
    display: block;
  }
  #container {
    max-width: 98%;
    height: calc(100% - 100px);
  }
  .cont-dir {
    width: 0 !important;
    background: #fff;
    height: calc(100% - 100px);
  }
  .width0 {
    width: 80% !important;
  }
  .left0 {
    left: 80% !important;
  }
  .left0 div{
    transform: rotate(180deg);
  }
}
</style>
